/**
* 状态管理仓库
*/
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'


// 模块
import common from './modules/common'
import detail from './modules/detail'
import list from './modules/list'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [createPersistedState({
    paths: ['detail']
  })],
  modules: {
    common,
    detail,
    list
  }
})

export default store



// WEBPACK FOOTER //
// ./src/stores/index.js